"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.primary = exports.themes = exports.MODE_KEY = exports.themesPalette = void 0;

var colors_1 = require("../colors");

var utils_1 = require("./utils");

exports.themesPalette = {
  wongnai: {
    primary: colors_1.orange
  },
  delivery: {
    primary: colors_1.green
  },
  cooking: {
    primary: colors_1.yellow
  },
  food: {
    primary: colors_1.corn
  },
  beauty: {
    primary: colors_1.pink
  },
  beautyProduct: {
    primary: colors_1.salmon
  },
  attraction: {
    primary: colors_1.cyan
  },
  accommodation: {
    primary: colors_1.teal
  },
  forBusiness: {
    primary: colors_1.orange
  },
  reserve: {
    primary: colors_1.scarlet
  },
  massageAtHome: {
    primary: colors_1.brick
  },
  deal: {
    primary: colors_1.red
  }
};
var THEME_KEYS = {
  primary: 'primary'
};
var themeKeys = Object.keys(THEME_KEYS);
exports.MODE_KEY = 'mode';
exports.themes = Object.keys(exports.themesPalette).reduce(function (acc, theme) {
  var _a;

  acc[theme] = themeKeys.reduce(function (accKeys, key) {
    accKeys[key] = theme;
    return accKeys;
  }, (_a = {}, _a[exports.MODE_KEY] = 'light', _a));
  return acc;
}, {});
exports.primary = utils_1.stylePalette(THEME_KEYS.primary);